// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d69bf8c","724":"bdbbc037"}[chunkId] + ".chunk.js";
};